module.exports = "/_next/static/images/c899ef9fe186c66e10d3364a46fb97d8-girl-and-card-xs.png.webp";